import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import * as Yup from 'yup';
import Get from "../../api/Get";
import { GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN, GET_ESPECIALIDAD_EPS, GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN } from "../../api/Routes";
import SelectAjax from "../../components/SelectAjax"
import SimpleLoad from "../../loader/SimpleLoad";
import ItemsDoctors from "../ItemsDoctors";
import moment from 'moment';
import Select from 'react-select'

function StepTwo({t, next, initialData, setInitialData, prev, linkAllianz, setShowModalError, setErrorServer}){
    const [especialidad, setEspecialidad]=useState(null)
    const [especialidadOpt, setEspecialidadOpt] = useState([])
    const [basicItems, setBasicItems] = useState([])
    const [items, setItems] = useState([])
    const [isSearch, setIsSearch] = useState(false)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0)
    const postsPerPage = 10;
    const [indexOfLastPost, setIndexOfLastPost] = useState(currentPage * postsPerPage);
    const [indexOfFirstPost, setIndexOfFirstPost] = useState(indexOfLastPost - postsPerPage);    

    const handleSubmit = (values) =>{
        next(values)
    }

    //console.log(linkAllianz)

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected+1)
        let indexLastP = (data.selected+1) * postsPerPage
        setIndexOfLastPost(indexLastP)
        setIndexOfFirstPost(indexLastP - postsPerPage)
    }

    const onClickShowCitaPatient = (hour, date, idHour, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        setInitialData(prev=>({
            ...prev,
            dayAppointment: date, 
            doctorId: doctorId,
            hourDayId: idHour,
            hourDayHour: hour,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: especialidad.label,
            especialidadId: especialidad.value
        }))
    }

    //console.log(linkAllianz)

    const shemaValidateStepOne = Yup.object().shape({
        hourInit: Yup.string()
           .required(t('Camporequerido')),
        doctorId: Yup.string()
          .required(t('Camporequerido'))
    });

    const [startChecking, setStartChecking] = useState([])
    const [checkIndex, setCheckIndex] = useState(-1)
    const [doctors, setDoctors] = useState([])
    const [doctorRef, setDoctorRef] = useState(null)
    const [countDr, setCountDr] = useState(0)

    useEffect(()=>{
        console.log(especialidad)
        if(especialidad !=null){
            setIsSearch(true)
            Get({url: `${GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN}/${especialidad.value}/${initialData.account.id}`, noToken: true})
            .then(response=>{
                //console.log(response)
                let its = response.data.data.response.map((it, index)=>({
                    doctor: it.doctor,
                    especialty: it.especialty,
                    formation: it.formation,
                    licence_number: it.licence_number,
                    values: []
                    
                }))
                //console.log(its)
                setStartChecking(its.map((el)=>(el.doctor.id)))
                setDoctors(its.map((el)=>(el.doctor)))
                setCheckIndex(-1)
                setIsSort(false)
                setBasicItems(its)
                setItems(its)
                if(response.data.data.response.length > 0){
                    //let pPage = linkAllianz ? its.length : postsPerPage
                    let pPage = its.length
                    let pC = Math.ceil(its.length / pPage)
                    setPageCount(pC)

                    // if(linkAllianz){
                    //     setCountDr(its.length)
                    //     setIndexOfFirstPost(0)
                    //     setIndexOfLastPost(its.length)
                    // }
                    setCountDr(its.length)
                    setIndexOfFirstPost(0)
                    setIndexOfLastPost(its.length)
                }
                setIsSearch(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }        
    }, [especialidad])

    const onClickSelectedSchedule = (horario, doctorId) =>{
        let d = items.filter(e=>e.doctor.id===doctorId)
        let schedule = {
            scheduleType:"Online",
            doctor: {
              id: doctorId
            },
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss")
        }
        setInitialData(prev=>({
            ...prev,
            hourInit: moment(horario.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            schedule: schedule,
            doctorId: doctorId,
            doctorName: `${d[0].doctor.name} ${d[0].doctor.lastName}`,
            especialidadName: especialidad.label,
            especialidadId: especialidad.value
        }))
        next()
    }

    const [isSort, setIsSort] = useState(false)
    const ordering = () =>{
        //console.log('ordering')
        //console.log(basicItems)
        let its = [...basicItems]
        //console.log(its)
        its.sort((itA,itB)=>{
            if(itA.values.length > 0 && itB.values.length > 0){
                
                let firstAH = moment(itA.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                let firstBH = moment(itB.values[0].dateTimeInit, "YYYY-MM-DDTHH:mm:ss")
                //console.log(firstAH)
                if(firstAH.isBefore(firstBH)){
                    return -1;
                }else{
                    return 1
                }
            }else if(itA.values.length === 0 && itB.values.length > 0){
                return 1
            }else if(itA.values.length > 0 && itB.values.length === 0){
                return -1
            }else{
                return 0
            }
        })
        //console.log('its')
        //console.log(its)
        setItems(its.filter(it=>it.values.length > 0))
        setIsSort(true)
        
    }   

    const onHandleChangeDoctor = (val) =>{
        //console.log(val)
        let aux1 = [...basicItems]
        if(!val){
            ordering()
            //setItems(basicItems)
        }else{
            //console.log(items)
            let aux = aux1.filter((el)=>el.doctor.id===val.value)
            setItems(aux)
        }
        //setCurrentPage(1)
        setDoctorRef(val)
    }

    useEffect(()=>{
        if(initialData.account.id===144){
            Get({url: `${GET_ESPECIALIDAD_EPS}/${initialData.account.id}?tipoPlan=${initialData.tipoPlan}`, noToken: true})
            .then(res=>{
                setEspecialidadOpt(res.data.data.response)
            })
            .catch(err=>{
                 console.log(err)
            })
        }else{
            Get({url: `${GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN}/${initialData.account.id}`, noToken: true})
            .then(res=>{           
                setEspecialidadOpt(res.data.data.response)
            })
            .catch(err=>{
                 console.log(err)
            })
        }
        
    }, [])
    

    return (
        <Formik
            initialValues={initialData}
            validationSchema={shemaValidateStepOne}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >{({
            errors,
            handleSubmit,
            setFieldValue
        })=>(
            <Form onSubmit={handleSubmit}>
                <Field type="hidden" name="dayAppointment" value={initialData.dayAppointment} />
                <Field type="hidden" name="doctorId" value={initialData.doctorId} />
                <Field type="hidden" name="hourDayId" value={initialData.hourDayId} />
                <Card className="mb-3">
                    <Card.Header className="text-center">
                        <Form.Group className="w-50 m-auto input-100">
                            <Form.Label className="text">{t('filtrar_especialidad')}</Form.Label>
                            <SelectAjax
                                defaultValue={especialidad === null || Object.keys(especialidad).length === 0 ? false : especialidad}
                                url={`${GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN}/${initialData.account.id}`}
                                access_token={null}
                                isMulti={false}
                                handleChange={(value) => setEspecialidad(value)} 
                                defaultOptions={especialidadOpt.map(el=>({label: el.name, value: el.id}))}   
                                valid={true}     
                                isClearable={false}
                                className="rounded"
                                placeholder="Selecciona la especialidad para tu cita"    
                                noToken={true}                                               
                            />
                        </Form.Group>                        
                    </Card.Header>
                    <Card.Body>
                        {
                            linkAllianz &&
                            <Row className="mb-md-4">
                                <Col className="text-right">
                                    <Button type="button" variant="primary" className="btn1" onClick={prev}>{t('regresar')}</Button>{' '}
                                    <Button type="submit" variant="primary" className="btn1">{t('siguiente')}</Button>
                                </Col>
                            </Row>
                        }
                        { 
                            (errors.hourInit || errors.doctorId) && 
                            <Alert variant="danger">{t('seleccionar_horario')}</Alert> 
                        }
                        {
                            initialData.schedule &&
                            <div className="alert-info p-3 rounded my-3">
                                <label>{t('cita_seleccionada')}</label>
                                <h6 className="mb-0">{t('doctor')}: {initialData.doctorName}</h6>
                                <h6 className="mb-0">{t('fecha')}: {moment(initialData.schedule.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")} hrs</h6>
                            </div>                            
                        }
                        {
                            isSearch ? 
                            <Row>
                                <Col className="position-relative overflow-hidden h-300px">
                                    <SimpleLoad />
                                </Col>
                            </Row> :
                            <Row>
                                {
                                    (items.length === 0 && especialidad != null) ?
                                    <Col>
                                        <Jumbotron>
                                            <h1 className="display-3">{t('lo_sentimos')}</h1>
                                            <label className="text-secondary">{t('not_found_expecialidad')}</label>
                                        </Jumbotron>
                                    </Col> :
                                    (items.length === 0 && especialidad == null) ?
                                    <Col>
                                        <Jumbotron>
                                            <label className="text-secondary">{t('seleccionar_especialidad')}</label>
                                        </Jumbotron>
                                    </Col> :
                                    <Col className="text-style">
                                        {
                                            linkAllianz && 
                                            <Row>
                                                <Col md="1" xs="12">
                                                    <label className="text-secondary">Filtrar por nombre</label>
                                                </Col>
                                                <Col md="4" xs="12">
                                                    <Select 
                                                        className="select-especialista"
                                                        defaultValue={ doctorRef }
                                                        value={ doctorRef }
                                                        options={ doctors.map(el=>({label: `${el.name} ${el.lastName}`, value: el.id})) }
                                                        onChange= {(val) =>onHandleChangeDoctor(val)}
                                                        isClearable
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        <ItemsDoctors 
                                            items={items} 
                                            handlePageClick={handlePageClick}
                                            indexOfLastPost={indexOfLastPost}
                                            indexOfFirstPost={indexOfFirstPost}
                                            pageCount={pageCount}
                                            onClickShowCitaPatient={onClickShowCitaPatient}
                                            auth={null}
                                            publico={true}
                                            account={initialData.account}
                                            onClickSelectedSchedule={onClickSelectedSchedule}
                                            currentPage={currentPage}
                                            linkAllianz={linkAllianz}
                                            isSort={isSort}
                                            setIsSort={setIsSort}
                                            ordering={ordering}
                                            startChecking={startChecking}
                                            setStartChecking={setStartChecking}
                                            checkIndex={checkIndex}
                                            setCheckIndex={setCheckIndex}
                                            setBasicItems={setBasicItems}
                                            basicItems={basicItems}
                                            doctorRef={doctorRef}
                                            countDr={countDr}
                                            setCountDr={setCountDr}
                                        />
                                    </Col>
                                }
                                
                            </Row>
                        }
                        
                        <Row className="mt-3">
                            <Col className="text-right">
                                <Button type="button" variant="primary" className="btn1" onClick={prev}>{t('regresar')}</Button>{' '}
                                <Button type="submit" variant="primary" className="btn1">{t('siguiente')}</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
        )}

        </Formik>
    )


}

export default withTranslation()(StepTwo)